import type {
  SetupWalletInstrumentArgs,
  ApiRedirectResult,
} from '../../api/types/payments.types';

import { setupWalletInstrument } from '../../api/wallet.api';
import { useMutation } from '../base';

/**
 * Starts the hosted card setup. The result (`ApiRedirectResult`) is passed
 * into `startProviderRedirect` — no invalidation (the page leaves the app,
 * the return is covered by polling from F1.2).
 */
export function useSetupWalletInstrument() {
  const response = useMutation<
    ApiRedirectResult | null,
    null,
    SetupWalletInstrumentArgs
  >({
    mutationFn: setupWalletInstrument,
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
